import {
    getProfileIdLoading,
    getProfileIdRequest,
    getProfileIdSuccess,
    getProfileIdReject,
} from "../../actions/profile/getId";

export const getProfileId = (formData) => async (dispatch, getState) => {
    dispatch(getProfileIdLoading());
    try {
        const { data } = await getProfileIdRequest(formData, getState);
        dispatch(getProfileIdSuccess(data))
    } catch (error) {
        dispatch(getProfileIdReject(error))
    }
    return Promise.resolve();
};